export default __webpack_public_path__ + "static/media/4.16062bb3.jpg";